import React from 'react';
import Marquee from 'react-fast-marquee';
import classNames from 'classnames';
import AmazonBusiness from '../../../static/images/partners/amazon-business.svg';
import BestBuy from '../../../static/images/partners/best-buy.svg';
import Bloomreach from '../../../static/images/partners/bloomreach.svg';
import Burberry from '../../../static/images/partners/burberry.svg';
import BuyWithPrime from '../../../static/images/partners/buy-with-prime.svg';
import Juni from '../../../static/images/partners/juni.svg';
import Postscript from '../../../static/images/partners/postscript.svg';
import Shopline from '../../../static/images/partners/shopline.svg';
import Typeform from '../../../static/images/partners/typeform.svg';
import Ups from '../../../static/images/partners/ups.svg';
import Xero from '../../../static/images/partners/xero.svg';
import Earnin from '../../../static/images/partners/earnin.svg';
import { useWindowSize } from '../../utils/helpers';

export const APartners = props => {
  const screenSize = useWindowSize();
  const partners = [
    { name: 'amazon-business', logo: AmazonBusiness },
    { name: 'buy-with-prime', logo: BuyWithPrime },
    { name: 'best-buy', logo: BestBuy },
    { name: 'typeform', logo: Typeform },
    { name: 'xero', logo: Xero },
    { name: 'burberry', logo: Burberry },
    { name: 'ups', logo: Ups },
    { name: 'bloomreach', logo: Bloomreach },
    { name: 'juni', logo: Juni },
    { name: 'postscript', logo: Postscript },
    { name: 'shopline', logo: Shopline },
    { name: 'earnin', logo: Earnin },
  ];

  return (
    <div className={classNames(props.className)}>
      <Marquee
        className="!overflow-visible sm:!overflow-hidden"
        gradient={
          props?.gradient === false
            ? false
            : screenSize.width < 768
              ? false
              : true
        }
        gradientWidth={115}
        gradientColor={props?.gradientColor || '#FFFFFF'}
        speed={30}
        autoFill={true}
      >
        {partners.map((partner, i) => (
          <div
            className={classNames('mx-6 sm:mx-8', {
              'brightness-100 invert': props.light,
              'custom-filter-primary-dark': props.primary,
              'custom-filter-secondary': props.secondary,
            })}
            key={i}
          >
            <img
              className="mix-blend-screen sm:scale-110"
              src={partner.logo}
              alt={partner.name}
              loading="lazy"
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
